$(document).ready( function(){

	  $('.search .action').stop().click(function(e){
        // alert('bob');
        if($(this).hasClass('ready')){
            // don't do nuffin
        }else{
            e.preventDefault();
            $('.search .query').animate(
                {right: "0"},
                250
            );
            $(this).toggleClass('ready');
        }
        
    });
});